import React from 'react';
import { Loader2 } from "lucide-react";
interface LoadingProps {
  title?: string;
}

const Loading: React.FC<LoadingProps> = ({ title = "Powston Dashboard" }) => {
  return (
    <div className="flex flex-col items-center justify-center dark:bg-gray-900">
      <div className="dark:bg-gray-800 p-8 rounded-lg shadow-lg text-center">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-200 mb-4">
          {title}
        </h1>
        <div className="flex items-center justify-center mb-4">
          <Loader2 className="h-12 w-12 text-blue-500 animate-spin" />
        </div>
        <p className="text-muted-foreground text-lg">
          Loading data...
        </p>
      </div>
    </div>
  );
};

export default Loading;